/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import PatchAddress from "App/utils/globe/chunk_lod/patch_address";
import TreeNode from "App/utils/globe/chunk_lod/tree/node";

export default
class DataHandler {
    private _attributesArray: any;
    protected _indicesArray: ArrayBuffer;
    protected _textureData: ArrayBuffer;
    protected _node: TreeNode;

    constructor(aNode: TreeNode) {
        this._attributesArray = null;
        this._indicesArray = null;
        this._textureData = null;

        this._node = aNode;
    }

    public getAttributes(aAddress: PatchAddress): any {
        return this._attributesArray;
    }

    public getIndices(): ArrayBuffer {
        return this._indicesArray;
    }

    public getTextureData(): ArrayBuffer {
        return this._textureData;
    }

    public fill(aData: any, aAddress: PatchAddress) {
    }
}
